import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from 'styled-components';
import { getColor } from '../../V2/Elements/Icons/helpers.js';
const Icon = React.forwardRef(function Icon({ size = 14, alt, color, className, onClick }, ref) {
    const theme = useTheme();
    const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
    return (_jsxs("svg", { ref: ref, onClick: onClick, width: size, height: size, viewBox: '0 0 14.000000000000002 13', fill: fillColor, className: className, children: [_jsx("g", { children: _jsx("rect", { fill: 'none', height: '15', width: '16', y: '-1', x: '-1' }) }), _jsx("g", { children: _jsx("path", { d: 'm10.987342,0.531645l-8,0c-1.1,0 -2,0.9 -2,2l0,8c0,1.1 0.9,2 2,2l8,0c1.1,0 2,-0.9 2,-2l0,-8c0,-1.1 -0.9,-2 -2,-2z' }) })] }));
});
export default React.memo(Icon);
